// eslint-disable-next-line import/no-namespace
import * as Yup from 'yup';



export default Yup;
